<template>
  <div class="container">
    <div class="columns box-title is-12">
      <div class="column is-6">
        <h4 class="has-text-left">
          <i class="fal fa-info"></i>
          ຍອດສາຂາທີ່ສ້າງ ແລະ ຈັດສົ່ງ COD ສຳເລັດ
          <span class="countTotal">({{ count }})</span>
        </h4>
      </div>

    </div>
    <div class="box">
      <div class="columns">
        <div class="column is-2">
          <div class="control">
            <label class="label">ຈາກວັນທີ:</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                v-model="start_date"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                name="start_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <label class="label">ຫາວັນທີ:</label>
            <date-picker
                format="DD/MM/YYYY"
                value-type="YYYY-MM-DD"
                type="date"
                v-model="end_date"
                :disabled-date="disabledAfterToday"
                :clearable="false"
                name="end_date"
            ></date-picker>
          </div>
        </div>
        <div class="column is-2">
          <div class="control">
            <label class="label">ປະເພດສາຂາ:</label>
            <div class="select">
              <select class="input" v-model="branch_type">
                <option value="">ທັງໝົດ</option>
                <option value="branch">ສາຂາຫຼັກທັງໝົດ</option>
                <option value="branch_capital">ສາຂາຫຼັກນະຄອນຫຼວງ</option>
                <option value="branch_province">ສາຂາຫຼັກຕ່າງແຂວງ</option>
                <option value="franchise">ແຟນຊາຍ</option>
              </select>
            </div>
          </div>
        </div>
        <div class="column is-2" style="margin-top: 3px">
          <vs-button
              ref="button" flat
              @click="printSummaryBranch()"
              class="form-btn-loading"
              :loading="loading">
            export excel
          </vs-button>
        </div>
      </div>
    </div>
    <div class="center fit-width">
      <vs-table ref="table">
        <template #thead>
          <vs-tr>
            <vs-th>ລຳດັບ</vs-th>
            <vs-th>ວັນທີສ້າງ</vs-th>
            <vs-th>ຊື່</vs-th>
            <vs-th>ສະຖານະ</vs-th>
            <vs-th></vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
              :key="index"
              :data="branch"
              v-for="(branch, index) in $vs.getPage(listPrint, page, max)">
            <vs-td>{{ index + 1 }}</vs-td>
            <vs-td>{{ moment(branch.created_at).format('DD-MM-YYYY HH:mm') }}</vs-td>
            <vs-td>{{ branch.name }}</vs-td>
            <vs-td>{{ laStatus[branch.status] }}</vs-td>
            <vs-td style="text-align: right; width: 100px">
              <div class="group-icon">
                <div v-if="branch.status === 1">
                  <vs-button circle icon flat @click="download(branch.id, branch.name)">
                    <i class="fal fa-download"></i>
                  </vs-button>
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </template>
        <template #footer>
          <pagination v-if="pagination.last_page > 1" :pagination="pagination" :offset="offset"
                      @paginate="FetchData"></pagination>
          <Loading v-if="isLoading"/>
        </template>
      </vs-table>
    </div>
  </div>
</template>
<script>
import Loading from "@/views/Loading";
import {mapActions} from "vuex";
import pagination from '@/Plugins/Paginations/Pagination';
import * as helper from "@/Helpers/GetValue";
import DatePicker from "vue2-datepicker";
import moment from "moment";

export default {
  components: {
    Loading,
    pagination,
    DatePicker
  },

  data: () => ({
    laStatus: {
      0: 'ກຳລັງດຳເນີນການ',
      1: 'ສຳເລັດ'
    },
    page: 1,
    max: 10,
    start_date: moment(new Date()).format('YYYY-MM-DD'),
    end_date: moment(new Date()).format('YYYY-MM-DD'),
    isLoading: false,
    branch: '',
    branch_type: '',
    branches: [],
    searchItem: "",
    oldVal: "",
    listPrint: [],
    // Pagination
    count: 0,
    offset: 10,
    limit_page: 10,
    pagination: {},

    //Export
    actualSelectedItems: [],
    isSelecting: false,
    pageInvoices: [],
    loading: false,
    checkedAll: false,
  }),
  methods: {
    download(id, filename) {
      this.$http.get(`download/cod/export/${id}`, {responseType: 'blob'})
          .then((response) => {
            const fileUrl = window.URL.createObjectURL(new Blob([response.data]))
            const fileLink = document.createElement('a')
            fileLink.href = fileUrl
            fileLink.setAttribute('download', filename)
            document.body.appendChild(fileLink)
            fileLink.click()
            document.body.removeChild(fileLink)
          }).catch((e) => console.log(e))
    },
    printSummaryBranch() {
      const loading = this.BtnLoading();
      this.loading = true;
      this.$http.post('/print/summary/cod/branch', {
        start_date: this.start_date,
        end_date: this.end_date,
        branch_type: this.branch_type
      }).then(() => {
        setTimeout(() => {
          this.loading = false;
          loading.close();
          this.FetchData();
        }, 500);
      }).catch(() => {
        this.loading = false;
        loading.close()
      });
    },


    FormatPrice(price) {
      let p = (parseInt(price) || 0).toFixed(2).split(".");
      return p[0].split("").reverse().reduce(function (acc, price, i) {
        return price === "-" ? acc : price + (i && !(i % 3) ? "," : "") + acc;
      }, "");
    },
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date > today;
    },
    disableDateCustomer(date) {
      const fixDay = moment('2021-08-01 00:00:00');
      return date < fixDay;
    },
    FetchData() {
      this.isLoading = true;
      this.fetchInvoiceItemsResponse().then((res) => {
        setTimeout(() => {
          this.listPrint = res.data.data;
          this.count = res.data.total;
          this.pagination = res.data;
          this.isLoading = false;
        }, 300);
      }).catch(() => {
        this.isLoading = false;
      });
    },

    fetchInvoiceItemsResponse(options = {}) {
      const {current_page, per_page} = options;
      return this.$http.get('list/print/summary/cod', {
        params: {
          page: current_page ?? this.pagination.current_page,
          per_page: per_page ?? this.limit_page,
        }
      })
    },
    FilterBySearch() {
      helper.GetOldValueOnInput(this);
    },
    ...mapActions({
      LogoutUser: "User/destroyToken",
    }),

    BtnLoading() {
      return this.$vs.loading({
        target: this.$refs.table,
        scale: "1",
        background: "primary",
        opacity: 1,
        color: "#195BFF",
      });
    },
  },
  created() {
    this.FetchData();
  }
};
</script>
<style lang="scss" scope>
.container {
  margin-top: 40px;

  .title-login {
    font-size: 20px;
    color: $primary-color;
  }
}

.fit-width {
  white-space: nowrap;
}

.vs-table__td,
.vs-table__th {
  vertical-align: middle !important;
  white-space: nowrap !important;
  width: 1px !important;
}

</style>
